import { useExperiment } from "@otta/search/hooks/unleash";
import { Experiment } from "@otta/search/constants/experiments";

export const APPLY_UNAVAILABLE_MESSAGE =
  "It's not possible to apply to this job right now. We're making some behind the scenes changes. Please try again later.";

interface ApplyableJob {
  acceptsInternalApplications?: boolean | null;
  originalUrl?: string | null;
}

interface ApplyAvailability {
  // When true, candidates can't use the apply-via-Otta flow for any job
  internalApplyDisabled: boolean;
  // When true, the job has no way to apply (internal only, with no original URL)
  applyUnavailable: boolean;
}

export function useApplyAvailability(job?: ApplyableJob): ApplyAvailability {
  const { variant } = useExperiment(Experiment.DisableInternalApply);
  const internalApplyDisabled = variant === "variant";

  return {
    internalApplyDisabled,
    applyUnavailable:
      internalApplyDisabled &&
      !!job?.acceptsInternalApplications &&
      !job.originalUrl,
  };
}
